import { useMutation, UseMutationOptions } from "react-query";
import { useCurrentTrip } from "@/hooks";
import { GATEWAY_URL } from "@/fetch/profiles/constants";
import useFetchWithAuth from "@/fetch/fetchWithAuth";
import { Passport } from "../usePersonalDetailsQuery";

type UpdatePassportVariables = {
  passport: Passport;
  correlationId: string;
};

type UpdatePassportResult = {
  message: string;
};

type QueryError = {};

const useUpdatePassportMutation = (
  options?: UseMutationOptions<
    UpdatePassportResult,
    QueryError,
    UpdatePassportVariables
  >
) => {
  const { fetchWithAuth, cancel } = useFetchWithAuth();
  const { currentTrip } = useCurrentTrip();
  const cid = currentTrip?.cid;

  return {
    ...useMutation<UpdatePassportResult, QueryError, UpdatePassportVariables>(
      async ({ passport, correlationId }: UpdatePassportVariables) => {
        const url = `${GATEWAY_URL}/traveller/${cid}/passport`;

        return fetchWithAuth<UpdatePassportResult>(url, {
          method: "POST",
          body: { ...passport, contexts: { active_trip: currentTrip?.id } },
          customHeaders: { [`X-CORRELATION-ID`]: correlationId },
        });
      },
      {
        ...options,
      }
    ),
    cancel,
  };
};

export default useUpdatePassportMutation;
